 const EditNecessaryRepaso = [
  {
    title: "Repaso de los campos y líneas clave editadas en tu contrato ERC20",
    value: `
A continuación, encontrarás un resumen de los campos que editaste en tu contrato inteligente ERC20 para tokenización inmobiliaria, con ejemplos y explicaciones claras para cada uno. ¡Utilízalo como checklist antes de desplegar tu contrato!

---

**1. Licencia**
\`\`\`solidity
// SPDX-License-Identifier: MIT
\`\`\`
Licencia abierta del contrato. Mantener como MIT a menos que requieras otra licencia.

---

**2. Autor**
\`\`\`solidity
/// @author CoachBlockchain
\`\`\`
Nombre del autor del contrato. Créditos educativos o institucionales.

---

**3. Nombre del token**
\`\`\`solidity
string public name = "MyRealToken";
\`\`\`
Nombre público del token que verán los usuarios en wallets y plataformas.  
**¡Cámbialo por el nombre de tu proyecto!**

---

**4. Símbolo del token (ticker)**
\`\`\`solidity
string public symbol = "MRT";
\`\`\`
Símbolo del token (3–4 letras). Aparecerá junto al nombre del token en exchanges.  
**¡Asegúrate de que sea único y corto!**

---

**5. Decimales**
\`\`\`solidity
uint8 public decimals = 18;
\`\`\`
Cantidad de decimales del token. Mantener en 18 para compatibilidad.

---

**6. Declaración del totalSupply**
\`\`\`solidity
uint public override totalSupply;
\`\`\`
La cantidad total de tokens se define en el constructor, aquí solo es la declaración.

---

**7. Definir totalSupply en el constructor**
\`\`\`solidity
totalSupply = 1_000_000 * 10 ** uint(decimals);
\`\`\`
Define cuántos tokens se crean en total, incluyendo los decimales.  
**Ejemplo:** Para un millón de tokens ERC20, así se representa el valor con 18 decimales.

---

**8. Distribución inicial de tokens**
\`\`\`solidity
balances[msg.sender] = totalSupply;
// O puedes usar tu propia dirección:
balances[0xTUWALLET] = totalSupply;
\`\`\`
Dirección que recibe todos los tokens al desplegar el contrato.  
**¡Reemplaza si quieres asignar los tokens a una wallet diferente a la del deploy!**

---

**Resumen:**
- Edita **name**, **symbol**, el **totalSupply** (constructor) y la **distribución inicial**.
- Revisa los campos **decimals**, **license** y **author** para asegurarte de que estén correctos.

¿Listo para compilar y desplegar?  
Este checklist te garantiza que tu contrato ERC20 está personalizado y profesional.
`
  }
];

export default EditNecessaryRepaso;